import React from 'react';
import classnames from 'classnames';
import IPfStickyHeaderMobile from './pfStickyHeaderMobile.d';
import styles from '../../stickyHeader/stickyHeader.scss';

const breakpoint767 = 767;

const placeholderRef = {
    current: {
        clientHeight: 0,
        getBoundingClientRect() {
            return { top: 0 };
        },
    },
};

function PfStickyHeaderMobile({ isEsApp, isGlobal, gridRef, children }: React.PropsWithChildren<IPfStickyHeaderMobile>) {
    const anchorRef = React.useRef<HTMLDivElement>();
    const [contentVisible, setContentVisible] = React.useState(false);
    let lastKnownScrollPosition = 0;

    const handleScrollOrResize = React.useCallback(() => {
        const scrollingUp = lastKnownScrollPosition > window.scrollY;
        const isMobile = window.innerWidth > breakpoint767;
        lastKnownScrollPosition = window.scrollY;

        const outerRef = anchorRef?.current ? anchorRef : placeholderRef;
        const outerRefTop = outerRef.current?.getBoundingClientRect().top ?
            outerRef.current.getBoundingClientRect().top : 0;
        const articleGridBottom = gridRef.current?.getBoundingClientRect().bottom;
        setContentVisible((scrollingUp || isMobile) && outerRefTop < 50 && articleGridBottom >= 50);
    }, []);

    let topValue = 50;
    if (isEsApp) {
        topValue = 0;
    } else if (isGlobal) {
        topValue = 90;
    }

    React.useEffect(() => {
        window.addEventListener('scroll', handleScrollOrResize);
        window.addEventListener('resize', handleScrollOrResize);

        return () => {
            window.removeEventListener('scroll', handleScrollOrResize);
            window.removeEventListener('resize', handleScrollOrResize);
        };
    }, []);

    return (
        <>
            <div ref={anchorRef as React.Ref<HTMLDivElement>} />
            <div
                className={classnames(styles.sticky_header, styles.pf_result, styles.mobile_header)}
                style={{
                    opacity: contentVisible ? 1 : 0,
                    pointerEvents: contentVisible ? 'initial' : 'none',
                    top: isEsApp ? 0 : topValue
                }}
            >
                <div
                    className={styles.content}
                >
                    {children}
                </div>
            </div>
        </>
    );
}

export default PfStickyHeaderMobile;
